import { render, staticRenderFns } from "./Hand.vue?vue&type=template&id=05801947&scoped=true"
import script from "./Hand.vue?vue&type=script&lang=ts"
export * from "./Hand.vue?vue&type=script&lang=ts"
import style0 from "./Hand.vue?vue&type=style&index=0&id=05801947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05801947",
  null
  
)

export default component.exports